import CreditCardIcon from '@liquidweb-dev/undercurrent/icons/lucide/CreditCard';
import LandmarkIcon from '@liquidweb-dev/undercurrent/icons/lucide/Landmark';
import ListIcon from '@liquidweb-dev/undercurrent/icons/lucide/List';
import MastercardIcon from '@liquidweb-dev/undercurrent/icons/platform/Mastercard';
import PayPalIcon from '@liquidweb-dev/undercurrent/icons/platform/PayPal';
import VisaIcon from '@liquidweb-dev/undercurrent/icons/platform/Visa';
import AmericanExpressLogo from '@liquidweb-dev/undercurrent/logos/AmericanExpress';
import DiscoverLogo from '@liquidweb-dev/undercurrent/logos/Discover';
import { FixedColorSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

export interface PaymentMethodIconProps extends FixedColorSvgProps {
	paymentMethod?: string;
	issuer?: string | null;
}

const PaymentMethodIcon = ({
	paymentMethod,
	issuer,
	...rest
}: PaymentMethodIconProps) => {
	if (paymentMethod?.toLowerCase() === 'check') {
		return <LandmarkIcon {...rest} />;
	}

	if (paymentMethod?.toLowerCase() === 'paypal') {
		return <PayPalIcon {...rest} />;
	}

	if (paymentMethod?.toLowerCase() === 'multiple') {
		return <ListIcon {...rest} />;
	}

	if (
		paymentMethod?.toLowerCase() === 'credit_card' ||
		paymentMethod?.toLowerCase() === 'creditcard'
	) {
		switch (issuer?.toLowerCase()) {
			case 'visa':
				return <VisaIcon {...rest} />;

			case 'mastercard':
				return <MastercardIcon {...rest} />;

			case 'discover':
				return <DiscoverLogo {...rest} />;

			case 'american_express':
				return <AmericanExpressLogo {...rest} />;

			default:
				return <CreditCardIcon {...rest} />;
		}
	}

	return null;
};

export default PaymentMethodIcon;
